import React, {useContext, useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {
  Autocomplete,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@mui/material';
import {Images} from '../../../common/Assets/Images';
import Switch from '@mui/material/Switch';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import IconButton from '@mui/material/IconButton';
import {DispatchContext} from '../../../store';
import CreateCurators from './CreateCurators';
import {usersActionServices, usersAPi} from '../../../services/UserServices';
import {museumApi} from '../../../services/MuseumServices';
import TextField from '@mui/material/TextField';
import {SNACKBAR_OPEN} from '../../../reducers';

export default function UserTable({roleId, meta, setMeta}) {
  const dispatch = useContext(DispatchContext);
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = React.useState(false);
  const [curatorId, setCuratorId] = useState(null);
  const [museums, setMuseums] = useState([]);
  const [museumId, setMuseumId] = useState(null);

  useEffect(() => {
    getCuratorList();
  }, [museumId, page, rowsPerPage]);

  useEffect(() => {
    getMuseums();
  }, []);

  const getMuseums = () => {
    museumApi('get').then(res => {
      setMuseums(res?.data);
    })
  }

  const getCuratorList = () => {
    usersAPi('get', {role_id: roleId, museum_id: museumId, page: page, per_page: rowsPerPage}).then(res => {
      setUsers(res?.data);
      setMeta(res?.meta);
    })
  }

  const handleChange = async (event, id) => {
    if (!event.target.checked) {
      await usersActionServices('put', id, null, {is_active: false});
      getCuratorList();
    } else {
      await usersActionServices('put', id, null, {is_active: true});
      getCuratorList();
    }
  };

  const handleChangePage = (event, newPage) => {
    dispatch({type: 'IS_NOT_LOADING', payload: false});
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleClose = () => {
    setOpen(false);
    setCuratorId(null);
  };

  const editMuseum = (id) => {
    setOpen(true);
    setCuratorId(id);
  }

  // const editMuseum = (id) => {
  //   usersActionServices('delete', id, null).then(res => {
  //     dispatch({
  //       type: SNACKBAR_OPEN,
  //       payload: {isNotify: true, severity: 'success', message: 'Curator updated successfully'}
  //     });
  //   })
  // }

  return (
    <React.Fragment>
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        options={museums}
        getOptionLabel={(option) => (option?.name)}
        size={'small'}
        onChange={(e, value) => {
          setMuseumId(value?.id || null);
        }}
        sx={{mb: 1.5, minWidth: 300, maxWidth: 400}}
        renderInput={(params) => <TextField {...params} label="Filter by museum" />}
      />
      <TableContainer component={Paper}>
        <Table sx={{minWidth: 650}} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell>Name / <span style={{color: '#B3B3B3'}}>Museum</span></TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Email</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Contact#</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Agency</TableCell>
              <TableCell colSpan={3} align="right"/>
            </TableRow>
          </TableHead>
          <TableBody>
            {users?.length > 0 && users?.map((user, index) => (
              <TableRow key={index}>
                <TableCell sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                  <img draggable={false} style={{width: 50, height: 50, borderRadius: 50}}
                       src={user?.profile?.photo || Images.logoWhite}
                       alt="profile"/>
                  <Box display='flex' flexDirection='column' sx={{ml: 1}}>
                    <Typography className={'text-capitalize'}
                                sx={{fontSize: 14, fontWeight: 600}}>{user?.first_name}</Typography>
                    {user?.museums?.map((museum, index) => {
                      return (<Typography key={index} sx={{
                        fontSize: 12,
                        fontWeight: 700,
                        color: '#6F7098'
                      }}>{museum?.name}</Typography>)
                    })}
                  </Box>
                </TableCell>
                <TableCell align="left">{user?.email || '-'}</TableCell>
                <TableCell align="left">{user?.phone || '-'}</TableCell>
                <TableCell align="left">{user?.profile?.agency || '-'}</TableCell>
                <TableCell align="center" sx={{width: 120}}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Switch
                      checked={user?.is_active === true}
                      onChange={(e) => handleChange(e, user?.id)}
                      inputProps={{'aria-label': 'controlled'}}
                    />
                    {user?.is_active === true ?
                      <Typography sx={{fontSize: 12}} color="primary">Active</Typography> :
                      <Typography sx={{fontSize: 12, color: '#F49609'}} color="error">Inactive</Typography>
                    }
                  </Stack>
                </TableCell>
                <TableCell align="center" sx={{width: 20}}>
                  <IconButton onClick={() => editMuseum(user?.id)}
                              sx={{bgcolor: '#fff', boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px;'}}>
                    <DriveFileRenameOutlineIcon/>
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 100]}
        page={page - 1}
        rowsPerPage={rowsPerPage}
        component="div"
        count={meta?.total}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {open &&
      <CreateCurators open={open} handleAction={handleClose} curatorId={curatorId} roleId={roleId}/>
      }
    </React.Fragment>
  );
}